import styled from 'styled-components'
import { motion } from 'framer-motion'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 56px - 24px);
  width: 100%;
  overflow: hidden;
`

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`

export const ListPix = styled.div`
  > div {
    border-bottom: 1px solid var(--gray200);
  }
  > div:last-child {
    border-bottom: none;
  }
`
const containerVariants = {
  hidden: { y: '10%', opacity: 0 },
  show: {
    y: '0%',
    opacity: 1,
    transition: {
      staggerChildren: 0.4,
      delayChildren: 0.4,
    },
  },
}

export const Actions = styled(motion.div).attrs({
  variants: containerVariants,
  initial: 'hidden',
  animate: 'show',
})`
  display: flex;
  flex-direction: column;
  padding: 24px 0;
`
